import { render, staticRenderFns } from "./AppBackButton.vue?vue&type=template&id=7a7b4e32&"
import script from "./AppBackButton.vue?vue&type=script&lang=js&"
export * from "./AppBackButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports